import axios from 'axios';
import {tApi} from 'tplus-api';
import mock from '../../module_biz/mock'
export default class VoucherApi{

      static async GetVoucherDTO(voucherTypeCode,voucherID){
        setLoading(true,'数据读取中...');
        const method = 'Ufida.T.BAP.Base.VoucherAPI.GetVoucherDTO';
        var param = {voucherTypeCode,voucherID};
        param.dataSource = 'mobile'
        param = {'apiParam':param};
        const resp = await tApi(param,method,false);
        setLoading(false);
        return resp;
      }

      static async GetVchDataTemplateDataType(voucherTypeCode){
        const key = `${voucherTypeCode}_TemplateDataType`;
        if(this[key]){
          return this[key];
        }
        setLoading(true,'获取数据模板中...');
        const method = 'Ufida.T.BAP.Base.VoucherAPI.GetVchDataTemplateDataType';
        var param = {voucherTypeCode};
        param.dataSource = 'mobile';
        param = {'apiParam':param};
        const resp = await tApi(param,method,false);
        this[key] = resp;
        setLoading(false);

        // this[key] = mock.DataTyteTemplate;
        // return mock.DataTyteTemplate;
        
        return resp;
      }
}
